import { addItemToCollection } from "directus/src/operations";


export async function createExtension({ item }) {
  try {
    const query = {
      fields: [
        "billable",
        "end_date",
        "justification",
      ],
    };

    const data = await addItemToCollection("billable_extensions", item, query);

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
